export const APPS_DATA_REQUESTS = {
  WELLS: 'WELLS',
  RIGS: 'RIGS',
  FRAC_FLEETS: 'FRAC_FLEETS',
  FRAC_FLEET_WELLS: 'FRAC_FLEET_WELLS',
  PAD_WELLS: 'PAD_WELLS',
};
